// extracted by mini-css-extract-plugin
module.exports = {"base":"ClusterHistoricalUsage_base__1hB_F","filters":"ClusterHistoricalUsage_filters__3cdS7"};